import { createAction } from 'redux-actions';
import types from './types';

export const getProjectsStats = createAction(types.GET_PROJECTS_STATS);
export const getProjectsStatsSuccess = createAction(types.GET_PROJECTS_STATS_SUCCESS);
export const getProjectsStatsError = createAction(types.GET_PROJECTS_STATS_ERROR);

export const setSelectedWard = createAction(types.SET_SELECTED_WARD);



// WEBPACK FOOTER //
// ./src/infraMonitor/projects-stats/actions.js